import React, { useEffect, useState } from 'react';
import '../../css/Dashboard.css';
import { useDashboardData } from './DashboardDataContext';
import { getQueryStatusClassName, getQueryStatusLabel } from '../../utils/queryStatus';

interface QueriesComponentProps {
  onCustomerClick: (customerId?: number) => void;
}

const QueriesComponent: React.FC<QueriesComponentProps> = ({ onCustomerClick }) => {
  const [queries, setQueries] = useState<any[]>([]);
  const formatRelative = (iso?: string) => {
    if (!iso) return '—';
    const d = new Date(iso);
    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const min = Math.floor(diffMs / 60000);
    if (min < 1) return 'just now';
    if (min < 60) return `${min}m ago`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr}h ago`;
    const days = Math.floor(hr / 24);
    return `${days}d ago`;
  };
  const { data } = useDashboardData();
  useEffect(() => {
    if (!data) return;
    const list = (data.recentQueries || []).map((q:any)=>({
      name: q.customer?.name || '—',
      customerId: q.customer?.id ?? q.customerId ?? q.customer_id,
      type: q.type,
      status: q.status,
      lastUpdated: q.queryDate,
    }));
    setQueries(list);
  }, [data]);

  return (
    <>
      <h4 className="card-title">Recent Queries</h4>
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Status</th>
              <th>Last Updated</th>
            </tr>
          </thead>
          <tbody>
            {queries.map((q, i) => (
              <tr key={i}>
                <td>
                  {q.customerId ? (
                    <button type="button" className="dashboard-customer-link" onClick={() => onCustomerClick(Number(q.customerId))}>
                      {q.name}
                    </button>
                  ) : q.name}
                </td>
                <td>{q.type}</td>
                <td>
                  <span className={`pill ${getQueryStatusClassName(q.status)}`}>{getQueryStatusLabel(q.status)}</span>
                </td>
                <td>{formatRelative(q.lastUpdated)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default QueriesComponent;
